import { useState } from 'react';
import Header from '../components/Header';
import CurrencySelection from '../components/CurrencySelection';
import PlanCards from '../components/PlanCards';
import PricingTable from '../components/PricingTable';
// import Testimonials from '../components/Testimonials';
import FAQ from '../components/FAQ';
import SocialMedia from '../components/SocialMedia';
import Footer from '../components/Footer';

const HomePage = () => {
  const [currency, setCurrency] = useState('USD');
  const [selectedSpread, setSelectedSpread] = useState('raw');
  const [selectedSteps, setSelectedSteps] = useState('two');
  const [selectedDemand, setSelectedDemand] = useState('on');
  const [selectedCard, setSelectedCard] = useState('prime');
  const [selectedPlatforms, setSelectedPlatforms] = useState({});
  const [planSlideIndex, setPlanSlideIndex] = useState(0);
  const [priceSlideIndex, setPriceSlideIndex] = useState(0);
  const [openFAQ, setOpenFAQ] = useState(null);

  // Handle platform selection
  const handlePlatformSelect = (planId, platform) => {
    setSelectedPlatforms(prev => ({
      ...prev,
      [planId]: platform
    }));
  };

  return (
    <>
      <div className="min-h-screen bg-gray-950 text-white font-sans">
        <Header />

        {/* Main Content */}
        <div className="max-w-7xl mx-auto px-6 py-12">
          <CurrencySelection currency={currency} setCurrency={setCurrency} />
          
          <PlanCards 
            selectedCard={selectedCard}
            setSelectedCard={setSelectedCard}
            selectedPlatforms={selectedPlatforms}
            setSelectedPlatforms={setSelectedPlatforms}
            handlePlatformSelect={handlePlatformSelect}
            planSlideIndex={planSlideIndex}
            setPlanSlideIndex={setPlanSlideIndex}
          />

          <PricingTable 
            selectedCard={selectedCard}
            selectedSpread={selectedSpread}
            selectedSteps={selectedSteps}
            selectedDemand={selectedDemand}
            currency={currency}
            selectedPlatforms={selectedPlatforms}
            priceSlideIndex={priceSlideIndex}
            setPriceSlideIndex={setPriceSlideIndex}
            setSelectedSpread={setSelectedSpread}
            setSelectedSteps={setSelectedSteps}
            setSelectedDemand={setSelectedDemand}
          />

          {/* <Testimonials /> */}

          <FAQ openFAQ={openFAQ} setOpenFAQ={setOpenFAQ} />

          <SocialMedia />
        </div>

        <Footer />
      </div>
    </>
  );
};

export default HomePage;
